<template>
<div>
  <v-container>
    <v-row>
      <v-col>
          <Confirm/>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import Confirm from '../../components/Admin/Confirm-data'

export default{
  components:{
    Confirm
  }
}
</script>


